<div *ngIf="node">
  <div id="node-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="node.name">{{node.name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Teams Role:</span>
      <span class="map-summary-item-value" [title]="node.teamsRole">{{node.teamsRole}}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="node.productType !== 'THIRD_PARTY'">
      <span class="map-summary-item-field">Address:</span>
      <span class="map-summary-item-value" [title]="node.addressForGUI">{{node.addressForGUI}}</span>
    </div>
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Device type:</span>
      <span class="map-summary-item-value" [title]="node.deviceTypeS">{{node.deviceTypeS}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Product type:</span>
      <span class="map-summary-item-value" [title]="node.productType">{{node.productType}}</span>
    </div>

    <div *ngIf="node.productType !== 'THIRD_PARTY'">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Software version:</span>
        <span class="map-summary-item-value" [title]="node.softwareVersion">{{node.softwareVersion}}</span>
      </div>
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Primary serial:</span>
        <span class="map-summary-item-value" [title]="node.serialNum">{{node.serialNum}}</span>
      </div>
    </div>

    <div class="map-summary-item-container" *ngIf="node.prevSerialNum != ''">
      <span class="map-summary-item-field">Secondary serial:</span>
      <span class="map-summary-item-value" [title]="node.prevSerialNum">{{node.prevSerialNum}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Administrative State:</span>
      <span class="map-summary-item-value" [title]="node.adminState">{{node.adminState}}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="node.topologyGroupsInfo">
      <span class="map-summary-item-field">Resource Groups:</span>
      <span class="map-summary-item-value" [title]="node.topologyGroupsInfo">{{node.topologyGroupsInfo}}</span>
    </div>


    <div *ngIf="node.productType !== 'THIRD_PARTY'">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Operative State:</span>
        <div class="map-summary-item-value-operative-state">
          <span (click)="isCollapsed = !isCollapsed" ng-style="node.operState.state === 15 ? {color: '#3382C6'} : {color:  'red'} ">{{node.operState.description}}</span>
          <i (click)="isCollapsed = !isCollapsed" [ngClass]="isCollapsed ? 'fa fa-angle-down fa-lg oper-state' : 'fa fa-angle-up fa-lg oper-state'"></i>
        </div>
      </div>

      <div [@openCloseNodeStates]="!isCollapsed">
        <div  *ngIf="node.routingServerGroupId < 1">
          <span class="map-summary-device-comment" style="color:red">There is no routing server group selected</span>
          <br/>
        </div>
        <span class="map-summary-device-left-operative-state">Configurator</span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true" [ngClass]="nodeOperativeStateToColor(node.operState.state).c2n"></i><span class="map-summary-device-right-operative-state">Node</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node</span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true" [ngClass]="nodeOperativeStateToColor(node.operState.state).n2c"></i><span class="map-summary-device-right-operative-state">Configurator</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node</span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true" [ngClass]="nodeOperativeStateToColor(node.operState.state).n2rR"></i><span class="map-summary-device-right-operative-state">Router *</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node *</span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true" [ngClass]="nodeOperativeStateToColor(node.operState.state).n2rN"></i><span class="map-summary-device-right-operative-state">Router</span>
        <br>
        <span class="map-summary-device-comment"> * Reporting element </span>
      </div>
    </div>

  </div>
  <div id="node-summary-charts">
    <div id="routing-attempt-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openRoutingAttemptsChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForRoutingAttempts"></arm-highchart>
      </div>
    </div>

    <div id="unsuccessful-routes-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openUnsuccessfulRoutesChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForUnsuccessfulRoutes"></arm-highchart>
      </div>
    </div>

    <div id="calls-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openCallsChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForCalls"></arm-highchart>
      </div>
    </div>
  </div>
</div>
